module.exports = __webpack_public_path__ + "img/comptafinance.3e3c2c94.png";